module.exports = __webpack_public_path__ + "static/img/vn.c15f3a92.png";